<div class="row mx-0">
  <h5 class="text-start text-primary fw-bold ps-2 ms-1 mb-5">Declaration and Terms & condition for Demat & Trading
    account </h5>
  <!-- <h6 class="text-start fw-bold ps-2 ms-1 mt-3 mb-2">Declaration</h6> -->
  <div class="col-lg-12 mt-3">
    <div class="d-md-flex row row-cols-auto">
      <!-- <div class="col-12 d-flex">
					<input class="ms-0 form-check-input" name="IndianCT" type="checkbox" value="Y" id="IndianCT"
						[(ngModel)]="IndianCT" (change)="IndianCTChange($event)">
					<label class="form-check-label ps-2" for="IndianC">I am an Indian citizen and a Tax resident of
						India
					</label>
				</div> -->
      <!-- <div class="col-12 d-flex mt-2">
					<input class="ms-0 form-check-input" name="politically" type="checkbox" value="Y" id="politically"
						[(ngModel)]="politically" (change)="politicallyChange($event)">
					<label class="form-check-label ps-2" for="politicall">I am an not politically-exposed (PEP) or
						related to a PEP
					</label>
				</div> -->

      <div class="col-12 d-flex mt-2">
        <input class="ms-0 form-check-input" name="Preferences" type="checkbox" value="Y" id="Preferences"
          [(ngModel)]="Preferences" (change)="PreferencesChange($event)">
        <label class="form-check-label ps-2" for="Preference"><span (click)="prefer()"
            class="text-primary link">Preferences</span> set by SBICAP Securities
        </label>
      </div>
      <!-- <div class="col-12 d-flex align-items-center mb-2 mt-2">
					<input class="form-check-input ms-0" type="checkbox" id="settled" [ngStyle]="isMobile ? {'width': '2em'} : {}" name="settled"
						[(ngModel)]="settled" (change)="settledChange($event)">

					<label class="form-check-label ps-2 mb-0" for="settle">
						Authority for maintenance of running account
					</label>

					<select class="form-select form-select-sm ms-2 w-auto d-inline-block text-primary link"
						id="FundSettleDays" name="FundSettleDays" [(ngModel)]="FundSettleDays"
						(change)="FundSettleDaysChange($event)">
						<option value="D">Daily</option>
						<option value="M">Monthly</option>
						<option value="Q">Quarterly</option>
					</select>
				</div> -->
      <div class="col-12 d-flex mt-2">
        <input class="ms-0 form-check-input" name="MITCTerms" type="checkbox" value="Y" id="MITCTerms"
          [(ngModel)]="MITCTerms" (change)="MITCTermsChange($event)">
        <label class="form-check-label ps-2" for="equity">Most important <span class="text-primary link"
            (click)="MitcTm()">Terms & Conditions</span></label>
      </div>


      <!-- <div class="col">
                    <input class="ms-lg-3 form-check-input" disabled  name="segments" type="checkbox" value="MF" id="mf" [(ngModel)]="mutualFund" (change)="segmentChange($event)">
                    <label class="form-check-label ps-2" for="mf">Mutual Funds</label>
                </div>
                <div class="col">
                    <input class="ms-md-0 form-check-input" name="segments" type="checkbox" value="F&O" id="fo" [(ngModel)]="futureOption" (change)="segmentChange($event)">
                    <label class="form-check-label ps-2" for="fo">Derivatives</label>
                </div> -->
    </div>
  </div>


</div>
<div class="footer d-flex align-items-end mx-0 mt-5 pt-5 row" *ngIf="termsStage">
  <div class="col-6 p-0">
    <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
  </div>
  <div class="col-6  p-0 text-end pe-md-3">
    <button class="btn btn-primary px-4" (click)="NextValidate()">AGREE ALL</button>
  </div>
</div>

<section class="modal fade" id="tradePR" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
    <div class="modal-content rounded">
      <div class="modal-header headshadow mb-3">
        <div class="modal-header-title text-bold onintraday">Preferences set by SBICAP Securities</div>
      </div>

      <div class="container-fluid tradescroll mt-3 text-black">

        <!-- Automatic Credit -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">Automatic Credit</div>
          <div class="card-body">
            <p>I/We authorise you to receive credit in my / our account without any instruction from me/ us.</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="AutomaticCredit" id="flexRadioAutomatic"
                  [(ngModel)]="autoCredit" value="Y" disabled />
                <label class="form-check-label" for="flexRadioAutomatic">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="AutomaticCredit" id="flexRadioAutomatic20"
                  [(ngModel)]="autoCredit" value="N" disabled />
                <label class="form-check-label" for="flexRadioAutomatic20">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Pledge -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">Pledge</div>
          <div class="card-body">
            <p>I / We would like to instruct the DP to accept all the pledge instructions in my / our account without
              any further instruction (default = No).</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="Pledge" id="flexPledge" [(ngModel)]="Pledge"
                  value="Y" disabled />
                <label class="form-check-label" for="flexPledge">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="Pledge" id="flexPledge2" [(ngModel)]="Pledge"
                  value="N" disabled />
                <label class="form-check-label" for="flexPledge2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- DIS -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">DIS</div>
          <div class="card-body">
            <p>I/We require Delivery Instruction Slip (DIS)</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="DIS" id="flexDIS" [(ngModel)]="DIS" value="Y"
                  disabled />
                <label class="form-check-label" for="flexDIS">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="DIS" id="flexDIS2" [(ngModel)]="DIS" value="N"
                  disabled />
                <label class="form-check-label" for="flexDIS2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- DDPI -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">DDPI Operations</div>
          <div class="card-body">
            <p>Account to be operated through DDPI</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="DDPI" id="flexDDPI" [(ngModel)]="tDDPI" value="Y"
                  disabled />
                <label class="form-check-label" for="flexDDPI">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="DDPI" id="flexDDPI2" [(ngModel)]="tDDPI" value="N"
                  disabled />
                <label class="form-check-label" for="flexDDPI2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- SMS Alert -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">SMS Alert Facility</div>
          <div class="card-body">
            <p>Mandatory if you are giving DDPI. Ensure mobile number is in KYC Form</p>

            <div class="d-flex">
              <div class="col-md-3 col-6">First Holder</div>
              <div class="col-md-9 col-6 d-flex">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="FirstHold" id="flexFirst" [(ngModel)]="FirstHold"
                    value="Y" disabled />
                  <label class="form-check-label" for="flexFirst">Yes</label>
                </div>
                <div class="form-check ms-5">
                  <input class="form-check-input" type="radio" name="FirstHold" id="flexFirst2" [(ngModel)]="FirstHold"
                    value="N" disabled />
                  <label class="form-check-label" for="flexFirst2">No</label>
                </div>
              </div>
            </div>

            <div class="d-flex mt-2">
              <div class="col-md-3 col-6">Second Holder</div>
              <div class="col-md-9 col-6 d-flex">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="SecondHold" id="flexSecond"
                    [(ngModel)]="SecondHold" value="Y" disabled />
                  <label class="form-check-label" for="flexSecond">Yes</label>
                </div>
                <div class="form-check ms-5">
                  <input class="form-check-input" type="radio" name="SecondHold" id="flexSecond2"
                    [(ngModel)]="SecondHold" value="N" disabled />
                  <label class="form-check-label" for="flexSecond2">No</label>
                </div>
              </div>
            </div>

            <div class="d-flex mt-2">
              <div class="col-md-3 col-6">Third Holder</div>
              <div class="col-md-9 col-6 d-flex">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="ThirdHold" id="flexThree" [(ngModel)]="ThreeHold"
                    value="Y" disabled />
                  <label class="form-check-label" for="flexThree">Yes</label>
                </div>
                <div class="form-check ms-5">
                  <input class="form-check-input" type="radio" name="ThirdHold" id="flexThree3" [(ngModel)]="ThreeHold"
                    value="N" disabled />
                  <label class="form-check-label" for="flexThree3">No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ECS -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">ECS Mandate</div>
          <div class="card-body">
            <p>Do you wish to receive dividend/interest via ECS? (default = Yes)</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="ECS" id="flexECS" [(ngModel)]="ECS" value="Y"
                  disabled />
                <label class="form-check-label" for="flexECS">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="ECS" id="flexECS2" [(ngModel)]="ECS" value="N"
                  disabled />
                <label class="form-check-label" for="flexECS2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- BSDA -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">BSDA Facility</div>
          <div class="card-body">
            <p>I/We wish to avail the BSDA facility</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="BSDA" id="flexBSDA" [(ngModel)]="BSDA" value="Y"
                  disabled />
                <label class="form-check-label" for="flexBSDA">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="BSDA" id="flexBSDA2" [(ngModel)]="BSDA" value="N"
                  disabled />
                <label class="form-check-label" for="flexBSDA2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Account Statement -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">Account Statement</div>
          <div class="card-body">
            <div class="d-md-flex flex-wrap">
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="AccountState" id="flexAccountSEBI"
                  [(ngModel)]="tSEBI" value="SEBI" disabled />
                <label class="form-check-label" for="flexAccountSEBI">As per SEBI Regulation</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="AccountState" id="flexAccountDaily"
                  [(ngModel)]="tSEBI" value="Daily" disabled />
                <label class="form-check-label" for="flexAccountDaily">Daily</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="AccountState" id="flexAccountWeekly"
                  [(ngModel)]="tSEBI" value="Weekly" disabled />
                <label class="form-check-label" for="flexAccountWeekly">Weekly</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="AccountState" id="flexAccountFortnightly"
                  [(ngModel)]="tSEBI" value="Fortnightly" disabled />
                <label class="form-check-label" for="flexAccountFortnightly">Fortnightly</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="AccountState" id="flexAccountMonthly"
                  [(ngModel)]="tSEBI" value="Monthly" disabled />
                <label class="form-check-label" for="flexAccountMonthly">Monthly</label>
              </div>
            </div>
          </div>
        </div>

        <!-- RTA -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">RTA</div>
          <div class="card-body">
            <p>I/We would like to share the email ID with the RTA</p>
            <div class="d-flex">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="RTA" id="flexRTA" [(ngModel)]="tRTA" value="Y"
                  disabled />
                <label class="form-check-label" for="flexRTA">Yes</label>
              </div>
              <div class="form-check ms-5">
                <input class="form-check-input" type="radio" name="RTA" id="flexRTA2" [(ngModel)]="tRTA" value="N"
                  disabled />
                <label class="form-check-label" for="flexRTA2">No</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Standard Documents -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">Standard Documents / Annual Report</div>
          <div class="card-body">
            <div class="d-md-flex flex-wrap">
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="SDAR" id="flexElectronic" [(ngModel)]="TElectronic"
                  value="Electronic" disabled />
                <label class="form-check-label" for="flexElectronic">Electronic</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="SDAR" id="flexPhysical" [(ngModel)]="TElectronic"
                  value="Physical" disabled />
                <label class="form-check-label" for="flexPhysical">Physical</label>
              </div>
              <div class="form-check me-4">
                <input class="form-check-input" type="radio" name="SDAR" id="flexPhysicalAndElectronic"
                  [(ngModel)]="TElectronic" value="PhysicalElectronic" disabled />
                <label class="form-check-label" for="flexPhysicalAndElectronic">Both Physical & Electronic</label>
              </div>
            </div>
            <p class="mt-2">(If not marked the default option would be Physical)</p>
          </div>
        </div>

        <!-- Easi / Ideas -->
        <div class="card1 p-0">
          <div class="card-header fw-bold text-white">easi / Ideas</div>
          <div class="card-body">
            <p>If yes, please complete registration through depository website.</p>
            <p>[BO can view ISIN balances, transactions and portfolio online through Depository website]</p>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="d-flex align-items-center justify-content-center my-5 mx-4">
        <button type="button" class="btn btn-primary secbut pcacs-tabs scrolltop order-md-2" data-bs-dismiss="modal">
          I Agree
        </button>
      </div>
    </div>
  </div>
</section>
<section class="modal fade" id="MitcT" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
    <div class="modal-content rounded">
      <div class="modal-header headshadow mb-3">
        <div class="modal-header-title text-bold onintraday ">Most Important Terms and Conditions (MITC)</div>
      </div>
      <div style="max-height: 400px;overflow-y: scroll;">
        <p class="pl-4 fw-bold mx-2 text-dark">Terms and Conditions</p>
        <P class="pl-4 mx-2">I am fully aware and hereby agree to:</P>
        <!-- <div class="d-flex justify-content-center align-items-center mt-3 fw-bold text-dark f-16">Annexure A </div> -->
        <div class="d-flex justify-content-center align-items-center mt-3 text-dark text-decoration-underline fw-bold">
          MOST IMPORTANT TERMS AND CONDITIONS (MITC)</div>
        <div class="d-flex justify-content-center align-items-center mt-3 text-dark">ANNEXURE A - (MITC FOR
          NON-CUSTODIAL SETTLED TRADING ACCOUNTS)</div>
        <div class="container-fluid tradescroll1 mt-3 text-black px-5">


          <ul style="list-style-type: disc !important;">
            <li class="my-3">Your trading account has a “Unique Client Code” (UCC), different from your Demat account
              number. Do not allow anyone (including your own stock broker, their representatives and dealers) to trade
              in your trading account on their own without taking specific instruction from you for your trades. Do not
              share your internet/ mobile trading login credentials with anyone else.</li>
            <li class="my-3">You are required to place collaterals as margins with the stock broker before you trade.
              The collateral can either be in the form of funds transfer into specified stock broker bank accounts or
              margin pledge of securities from your Demat account. The bank accounts are listed on the stock broker
              website. Please do not transfer funds into any other account. The stock broker is not permitted to accept
              any cash from you.</li>
            <li class="my-3">The stock broker’s Risk Management Policy provides details about how the trading limits
              will be given to you, and the tariff sheet provides the charges that the stock broker will levy on you.
            </li>
            <li class="my-3">All securities purchased by you will be transferred to your Demat account within one
              working day of the payout. In case of securities purchased but not fully paid by you, the transfer of the
              same may be subject to limited period pledge i.e. seven trading days after the pay-out (CUSPA pledge)
              created in favor of the stock broker. You can view your Demat account balances directly at the website of
              the Depositories after creating a login.</li>
            <li class="my-3">The stock broker is obligated to deposit all funds received from you with any of the
              Clearing Corporations duly allocated in your name. The stock broker is further mandated to return excess
              funds as per applicable norms to you at the time of quarterly/ monthly settlement. You can view the
              amounts allocated to you directly at the website of the Clearing Corporation(s).</li>
            <li class="my-3">You will get a contract note from the stock broker within 24 hours of the trade.</li>
            <li class="my-3">You may give a one-time Demat Debit and Pledge Instruction (DDPI) authority to your stock
              broker for limited access to your Demat account, including transferring securities, which are sold in your
              account for pay-in.</li>
            <li class="my-3">The stock broker is expected to know your financial status and monitor your accounts
              accordingly. Do share all financial information (e.g. income, Net-worth, etc.) with the stock broker as
              and when requested for. Kindly also keep your email Id and mobile phone details with the stock broker
              always updated.</li>
            <li class="my-3">In case of disputes with the stock broker, you can raise a grievance on the dedicated
              investor grievance ID of the stock broker. You can also approach the stock exchanges and/or SEBI directly.
            </li>
            <li class="my-3">Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature are
              prohibited by law. You will not have any protection/recourse from SEBI/stock exchanges for participation
              in such schemes.</li>
          </ul>

        </div>
        <div class="d-flex justify-content-center align-items-center mt-3 text-dark">TERMS AND CONDITIONS FOR RESEARCH
          ANALYST</div>
        <div class="container-fluid tradescroll1 mt-3 text-black px-5">
          <ul style="list-style-type: disc !important;">
            <li>
              Availing the research services: By accepting delivery of the research service, the client confirms that
              he/she has elected to subscribe the research service offered by SBICAP Securities Limited (herein after
              referred to as “SSL”) at his/her sole discretion. SSL confirms that research services shall be rendered in
              accordance with the applicable provisions of the SEBI’s Research Analyst (RA) Regulations.
            </li>
            <li>Obligations on RA: SSL and client shall be bound by SEBI Act and all the applicable rules and
              regulations of SEBI, including the RA Regulations and relevant notifications of Government, as may be in
              force, from time to time.
            </li>
            <li>
              Client Information and KYC: The client shall furnish all such details in full as may be required by SSL in
              its standard form with supporting details, if required, as may be made mandatory by RAASB/SEBI from time
              to time. SSL shall collect, store, upload and check KYC records of the clients with KYC Registration
              Agency (KRA) as specified by SEBI from time to time.

            </li>
            <li>
              Standard Terms of Service: The client hereby consents that:
              <ul style="list-style-type: disc !important;">
                <li>
                  I / We have read and understood the terms and conditions applicable to a research analyst as defined
                  under regulation 2(1)(u) of the SEBI (Research Analyst) Regulations, 2014, including the fee
                  structure.
                </li>
                <li>
                  I/We are subscribing to the research services for our own benefits and consumption, and any reliance
                  placed on the research report provided by research analyst shall be as per our own judgement and
                  assessment of the conclusions contained in the research report.
                </li>
                <li>
                  I/We understand that –
                  <ul>
                    <li>
                      Any investment made based on the recommendations in the research report are subject to market
                      risk.

                    </li>
                    <li>
                      Recommendations in the research report do not provide any assurance of returns.

                    </li>
                    <li>
                      There is no recourse to claim any losses incurred on the investments made based on the
                      recommendations in the research report.” SSL “hereby declares and confirms that:

                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              It is duly registered with SEBI as an RA pursuant to the SEBI (Research Analysts) Regulations, 2014 and
              its registration details are: (SEBI Regn No: INH000000602);

            </li>
            <li>
              It has registration and qualifications required to render the services contemplated under the RA
              Regulations, and the same are valid and subsisting;

            </li>
            <li>
              Research analyst services provided by it do not conflict with or violate any provision of law, rule or
              regulation, contract, or other instrument to which it is a party or to which any of its property is or may
              be subject;
            </li>
            <li>
              The maximum fee that may be charged by RA is ₹1.51 lakhs per annum per family to Individual and HUF
              clients.

            </li>
            <li>
              The recommendations provided by RA do not provide any assurance of returns.
            </li>
            <li>
              Consideration and mode of payment: The client shall duly pay to SSL, the agreed fees for the services that
              the company renders to the client and statutory charges, as applicable. Such fees and statutory charges
              shall be payable through the specified manner and mode(s)/ mechanism(s).
            </li>
            <li>
              Risk factors: The recommendations provided by SSL in the capacity of a Research Analyst and distributed as
              per SEBI (Research Analysts) Regulations 2014. Such recommendations do not constitute an offer or
              solicitation for the purchase or sale of any financial instrument or as an official confirmation of any
              transaction. The information contained therein is from publicly available data or other sources believed
              to be reliable. Such recommendations shall be provided for assistance only and are not intended to be and
              must not alone be taken as the basis for an investment decision. The user assumes the entire risk of any
              use made of such information. Each recipient of such research services should make such investigation as
              it deems necessary to arrive at an independent evaluation of an investment in the securities of companies
              referred to in this document (including the merits and risks involved), and should consult his own
              advisors to determine the merits and risks of such investment. The investment discussed or views expressed
              may not be suitable for all investors. SSL or any of its associates / group companies shall not be in any
              way responsible for any loss or damage that may arise to any person from any inadvertent error in the
              information contained in such recommendation.
            </li>
            <li>
              Conflict of interest: SSL shall adhere to the applicable regulations/ circulars/ directions specified by
              SEBI from time to time in relation to disclosure and mitigation of any actual or potential conflict of
              interest. SSL shall disclose any potential/material conflict of interest with respect to any
              recommendation and related information and opinions at the time of publication of research report or at
              the time of public appearance.

            </li>
            <li>
              Termination of service and refund of fees: In case of suspension of certificate of registration of SSL for
              more than 60 (sixty) days or cancellation of the RA registration, SSL shall refund the fees, on a pro rata
              basis for the period from the effective date of cancellation/ suspension to end of the subscription
              period.

            </li>
            <li>
              Grievance redressal and dispute resolution: Any grievance related to (i) non- receipt of research report
              or (ii) missing pages or inability to download the entire report, or (iii) any other deficiency in the
              research services provided by RA, shall be escalated promptly by the client by reaching out to SSL’s
              Helpdesk at helpdesk@sbicapsec.com or 022 68545555/022 40014155
              <ul style="list-style-type: disc !important;">
                <li>
                  SSL shall be responsible to resolve grievances within 7 (seven) business working days or such
                  timelines as may be specified by SEBI under the RA Regulations. SSL shall redress grievances of the
                  client in a timely and transparent manner. Any dispute between SSL and his client may be resolved
                  through arbitration or through any other modes or mechanism as specified by SEBI from time to time.

                </li>
              </ul>
            </li>
            <li>
              Additional clauses: Any additional voluntary clauses added by SSL should not be in contravention with
              rules/ regulations/ circulars of SEBI. Any changes in such voluntary clauses/document(s) shall be preceded
              by a notice of 15 days.

            </li>
            <li>
              Mandatory notice: Clients shall be requested to go through Do’s and Don’ts while dealing with RA as
              specified in SEBI master circular no. SEBI/HO/MIRSD-POD- 1/P/CIR/2024/49 dated May 21, 2024 or as may be
              specified by SEBI from time to time.

            </li>
            <li>
              Optional Centralised Fee Collection Mechanism: As may be applicable, SSL Shall provide the guidance to
              their clients on an optional ‘Centralised Fee Collection Mechanism for IA and RA’(CeFCoM) available to
              them for payment of fees to RA.

            </li>
          </ul>
        </div>

        <!-- MITC B -->
        <div class="d-flex justify-content-center align-items-center mt-3 text-dark text-decoration-underline fw-bold">
          MOST IMPORTANT TERMS AND CONDITIONS (MITC)</div>
        <div class="d-flex justify-content-center align-items-center mt-3 text-dark">ANNEXURE B – MITC FOR PROVIDING
          RESEARCH SERVICES</div>
        <div class="container-fluid tradescroll1 mt-3 text-black px-5">


          <ul style="list-style-type: disc !important;">
            <li class="my-3 f-14">These terms and conditions, and consent thereon are for the research services provided
              by the Research Analyst (RA) and RA cannot execute/carry out any trade (purchase/sell transaction) on
              behalf of, the client. Thus, the clients are advised not to permit RA to execute any trade on their
              behalf.</li>
            <li class="my-3 f-14">The fee charged by RA to the client will be subject to the maximum of amount
              prescribed by SEBI/ Research Analyst Administration and Supervisory Body (RAASB) from time to time
              (applicable only for Individual and HUF Clients).
              <p class="fw-bold">Note:</p>
              <ul class="pl-5" style="list-style-type: disc !important;">
                <li class="my-3 f-14">The current fee limit is Rs 1,51,000/- per annum per family of client for all
                  research services of the RA.</li>
                <li class="my-3 f-14">The fee limit does not include statutory charges.</li>
                <li class="my-3 f-14">The fee limits do not apply to a non-individual client / accredited investor.</li>
              </ul>
            </li>
            <li class="my-3 f-14">RA may charge fees in advance if agreed by the client. Such advance shall not exceed
              the period stipulated by SEBI; presently it is one quarter. In case of pre-mature termination of the RA
              services by either the client or the RA, the client shall be entitled to seek refund of proportionate fees
              only for unexpired period.</li>
            <li class="my-3 f-14">Fees to RA may be paid by the client through any of the specified modes like cheque,
              online bank transfer, UPI, etc. Cash payment is not allowed. Optionally the client can make payments
              through Centralized Fee Collection Mechanism (CeFCoM) managed by BSE Limited (i.e. currently recognized
              RAASB).</li>
            <li class="my-3 f-14">The RA is required to abide by the applicable regulations/ circulars/ directions
              specified by SEBI and RAASB from time to time in relation to disclosure and mitigation of any actual or
              potential conflict of interest. The RA will endeavor to promptly inform the client of any conflict of
              interest that may affect the services being rendered to the client.</li>
            <li class="my-3 f-14">Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature
              are prohibited by law. No scheme of this nature shall be offered to the client by the RA.</li>
            <li class="my-3 f-14">The RA cannot guarantee returns, profits, accuracy, or risk-free investments from the
              use of the RA’s research services. All opinions, projections, estimates of the RA are based on the
              analysis of available data under certain assumptions as of the date of preparation/publication of research
              report.</li>
            <li class="my-3 f-14">Any investment made based on recommendations in research reports are subject to market
              risks, and recommendations do not provide any assurance of returns. There is no recourse to claim any
              losses incurred on the investments made based on the recommendations in the research report. Any reliance
              placed on the research report provided by the RA shall be as per the client’s own judgement and assessment
              of the conclusions contained in the research report.</li>
            <li class="my-3 f-14">The SEBI registration, Enlistment with RAASB, and NISM certification do not guarantee
              the performance of the RA or assure any returns to the client.</li>
            <li class="my-3 f-14">For any grievances,
              <ul class="pl-5" style="list-style-type: disc !important;">
                <li class="my-3 f-14"> <strong>Step 1: </strong> the client should first contact the RA using the
                  details on its website or following
                  contact details:
                  <p>For any grievances, Email to <a
                      href="mailto:helpdesk@sbicapsec.com">mailto:helpdesk@sbicapsec.com</a> or visit<a
                      href="https://www.sbisecurities.in" target="_blank"> https://www.sbisecurities.in </a> </p>
                </li>
                <li class="my-3 f-14"> <strong>Step 2: </strong> If the resolution is unsatisfactory, the client can
                  also lodge grievances through
                  SEBI’s SCORES platform at <a href="https://www.scores.sebi.gov.in"
                    target="_blank">https://www.scores.sebi.gov.in </a>
                </li>
                <li class="my-3 f-14"> <strong>Step 3: </strong>The client may also consider the Online Dispute
                  Resolution (ODR) through the Smart ODR portal at <a href="https://smartodr.in"
                    target="_blank">https://smartodr.in</a>
                  <ul class="pl-5" style="list-style-type: disc !important;">
                  </ul>
                </li>
              </ul>
            </li>
            <li class="my-3 f-14">Clients are required to keep contact details, including email id and mobile number/s
              updated with the RA at all times.</li>
            <li class="my-3 f-14">The RA shall never ask for the client’s login credentials and OTPs for the client’s
              Trading Account Demat Account and Bank Account. Never share such information with anyone including RA.
            </li>

          </ul>
          <p><strong>Note: </strong>Disclosure as to Proprietary Trades by SSL: SSL may carry out
            proprietary trades in addition to trades on behalf of its Clients.</p>

        </div>

      </div>

      <div class="d-flex align-items-center justify-content-center my-5 mx-4">
        <button type="button" class="btn btn-primary  secbut pcacs-tabs scrolltop order-md-2" data-bs-dismiss="modal">
          I Agree
        </button>
      </div>
    </div>
  </div>
</section>

<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>